import { useEffect } from 'react';

type UseScrollToSectionParams = {
  sectionId: string;
  isEnabled: boolean;
};

export function useScrollToSection({ sectionId, isEnabled }: UseScrollToSectionParams) {
  useEffect(() => {
    if (!isEnabled || !sectionId) {
      return;
    }

    document.querySelector(`[data-node-id="${sectionId}"]`)?.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth',
    });
  }, [isEnabled, sectionId]);
}
